import "./ios_install";
import "./mount_components";

import $ from 'cash-dom'

$( document ).ready(() =>  {
  if ( window.innerWidth < 500 ) {
    $(".remove-on-mobile").each((i, el) => { $(el).removeClass("carousel-item") ; $(el).css("display", "none") })
  }
})
